import React, { useState, useEffect } from "react";
import { Phone, X } from "lucide-react";
import { trackCall } from "@/lib/track";

const PHONE = "+61362887861";
const PHONE_DISPLAY = "(03) 6288 7861";

export const CallFab = () => {
  const [hidden, setHidden] = useState(false);

  // Persist dismissal for the session
  useEffect(() => {
    if (sessionStorage.getItem("ta_call_fab_dismissed") === "1") {
      setHidden(true);
    }
  }, []);

  const onCall = () => {
    trackCall("call_fab");
  };

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHidden(true);
    sessionStorage.setItem("ta_call_fab_dismissed", "1");
  };

  if (hidden) return null;

  return (
    <>
      {/* Mobile floating button */}
      <a
        href={`tel:${PHONE}`}
        onClick={onCall}
        data-testid="call-fab-mobile"
        aria-label={`Call Tassie Automotive on ${PHONE_DISPLAY}`}
        className="md:hidden fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 pl-4 pr-5 py-3.5 bg-brand-red text-white font-bold uppercase tracking-wider text-xs shadow-2xl ring-1 ring-black/30 hover:bg-[#B91C2B] active:scale-95 transition-transform"
      >
        <span className="relative flex h-7 w-7 items-center justify-center">
          <span className="absolute inset-0 rounded-full bg-white/25 animate-ping" />
          <Phone className="h-4 w-4" />
        </span>
        Call now
        <button
          onClick={dismiss}
          data-testid="call-fab-dismiss"
          aria-label="Hide call button"
          className="ml-1 -mr-2 h-6 w-6 grid place-items-center text-white/70 hover:text-white"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </a>

      {/* Desktop subtle call pill (bottom-left so it doesn't fight gears) */}
      <a
        href={`tel:${PHONE}`}
        onClick={onCall}
        data-testid="call-fab-desktop"
        className="hidden md:inline-flex fixed bottom-6 left-6 z-50 items-center gap-2 px-4 py-2.5 bg-black/80 backdrop-blur border border-brand-red/40 text-white font-mono text-[11px] uppercase tracking-widest hover:bg-brand-red"
      >
        <Phone className="h-3.5 w-3.5 text-brand-red group-hover:text-white" />
        {PHONE_DISPLAY}
      </a>
    </>
  );
};
